<template>
  <div class="editor">
    <div class="container">
      <p>
        {{ parseTranslation(NAV_UPLOAD_FILE) }} >
        <span>{{ parseTranslation(DOCUMENT_EDITOR) }}</span>
      </p>
      <h1>{{ parseTranslation(DOCUMENT_EDITOR) }}</h1>
      <div>
        <div class="survey-name">
          <div>
            <h2>{{ fileName }}</h2>
            <router-link to="/">{{ parseTranslation(ALL_SURVEYS) }}</router-link>
          </div>

          <div class="buttons">
            <button id="save" @click="saveSurvey">
              {{ parseTranslation(SAVE_DRAFT) }}
            </button>
            <button v-if="hasQuestions()" id="foward" @click="poswind">
              {{ parseTranslation(FORWARD) }}
            </button>
            <button id="build" @click="buildSurvey">
              {{ parseTranslation(BUILD_SURVEY) }}
            </button>
          </div>
        </div>
      </div>
      <div class="editor-header">
        <button id="auto-tag" @click="autoTag()">Auto-Tag</button>
        <button title="SHIFT + 1" id="q-tag" @click="tag('q')">
          {{ parseTranslation(QUESTION) }}
        </button>
        <button title="SHIFT + 2" id="a-tag" @click="tag('a')">
          {{ parseTranslation(ANSWER) }}
        </button>
        <button title="SHIFT + 3" id="s-tag" @click="tag('s')">
          {{ parseTranslation(SUB_QUESTION) }}
        </button>
        <button title="SHIFT + F1" class="group" @click="group()">
          {{ parseTranslation(GROUP) }}
        </button>

        <button title="SHIFT + q" id="clear" @click="clearTag"><Eraser /></button>
      </div>
      <div class="text-container">
        <textarea
          id="editorTextArea"
          ref="editArea"
          v-model="$store.getters.survey.text"
        />
        <div id="editor" contenteditable="true" ref="editAreaDiv"></div>
      </div>
    </div>

    <Loader v-if="loading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Loader from '@/components/loading/Loader'

import Eraser from '@/components/imgs/Eraser'

import * as translationEditor from './index.translations'

const { default: translations, ...translationKeys } = translationEditor

const keyCodes = {
  numberOne: 49,
  numberTwo: 50,
  numberThree: 51,
  letterQ: 81,
  letterS: 83,
  fOne: 112,
}

export default {
  name: 'editor',

  components: {
    Loader,
    Eraser,
  },

  data() {
    return {
      translations,
      ...translationKeys,
      lang: '',
      loading: false,
      questionColor: '#c992c9',
      answerColor: '#66a6d3',
      subQuestionColor: '#6b6d14',
      textColor: this.$store.getters.darkmode ? '#FFF' : '#000',
      text: document.getSelection(),
      regexpTag: /(<\s*[qas][^>]*>)(?!<[aqs]>)(.*?)[^</qas>](<\s*\/\s*[qas]>)/gi,
      regexpQStart: /(<\s*[q]*>)/gi,
      regexpQEnd: /(<\s*\/\s*[q]>)/gi,
      regexpAStart: /(<\s*[a]*>)/gi,
      regexpAEnd: /(<\s*\/\s*[a]>)/gi,
      regexpSStart: /(<\s*[s]*>)/gi,
      regexpSEnd: /(<\s*\/\s*[s]>)/gi,
    }
  },
  computed: {
    survey() {
      return this.$store.getters.survey
    },
    fileName() {
      return this.survey.name
    },
  },
  methods: {
    ...mapActions(['surveyRegister', 'sendMessage', 'executeSurveyAPICall']),

    group() {
      const group = '|gb|'

      document.execCommand('insertText', false, `\n${group}\n`)
    },

    initEditor(text) {
      this.$refs.editAreaDiv.innerText = text
      const temp = this.$refs.editAreaDiv.cloneNode(true)
      this.$refs.editAreaDiv.innerText = ''
      for (let i = 0; i < temp.childNodes.length; i++) {
        if (temp.childNodes[i].nodeName !== 'BR') {
          this.$refs.editAreaDiv.innerText += `<div> ${temp.childNodes[i].wholeText} </div>`
        } else {
          this.$refs.editAreaDiv.innerText += '<br>'
        }
      }
      this.$refs.editAreaDiv.innerText = this.$refs.editAreaDiv.innerText
        .replace(/((<br>)+)(<br>)/g, '$1')
        .replace(/(<\/div>)(<br>)/g, '$1')
      this.$refs.editAreaDiv.innerText = this.$refs.editAreaDiv.innerText.replace(
        this.regexpQStart,
        `<span style="color:${this.questionColor};">&qtag`,
      )
      this.$refs.editAreaDiv.innerText = this.$refs.editAreaDiv.innerText.replace(
        this.regexpQEnd,
        `&q/tag</span>`,
      )
      this.$refs.editAreaDiv.innerText = this.$refs.editAreaDiv.innerText.replace(
        this.regexpAStart,
        `<span style="color:${this.answerColor};">&atag`,
      )
      this.$refs.editAreaDiv.innerText = this.$refs.editAreaDiv.innerText.replace(
        this.regexpAEnd,
        `&a/tag</span>`,
      )
      this.$refs.editAreaDiv.innerText = this.$refs.editAreaDiv.innerText.replace(
        this.regexpSStart,
        `<span style="color:${this.subQuestionColor};">&stag`,
      )
      this.$refs.editAreaDiv.innerText = this.$refs.editAreaDiv.innerText.replace(
        this.regexpSEnd,
        `&s/tag</span>`,
      )
      this.$refs.editAreaDiv.innerHTML = this.$refs.editAreaDiv.innerText
      this.$refs.editAreaDiv.childNodes.forEach(element => {
        if (element.childNodes.length >= 2) {
          element.childNodes.forEach(childnode => {
            if (childnode.innerText) {
              childnode.innerText = childnode.innerText.replace(/&qtag/gi, '<q>')
              childnode.innerText = childnode.innerText.replace(/&q\/tag/gi, '</q>')
              childnode.innerText = childnode.innerText.replace(/&atag/gi, '<a>')
              childnode.innerText = childnode.innerText.replace(/&a\/tag/gi, '</a>')
              childnode.innerText = childnode.innerText.replace(/&stag/gi, '<s>')
              childnode.innerText = childnode.innerText.replace(/&s\/tag/gi, '</s>')
            }
          })
        }
      })
    },

    async autoTag() {
      if (this.loading) return

      const text = this.$refs.editAreaDiv.innerText.replace(/<[^>]*>/g, '')

      if (!text) return

      this.loading = true

      const autoTag = await this.executeSurveyAPICall({
        method: 'POST',
        path: 'survey/auto-tag',
        payload: { text },
      })

      if (!autoTag) return (this.loading = false)

      this.initEditor(autoTag.text)

      this.loading = false
    },

    tag(code) {
      const selRange = this.text.getRangeAt(0)
      const wrapper = document.querySelector('.text-container')
      if (this.$refs.editAreaDiv.contains(this.text.focusNode)) {
        if (!selRange.collapsed) {
          if (code === 'q') document.execCommand('foreColor', false, this.questionColor)
          else if (code === 'a')
            document.execCommand('foreColor', false, this.answerColor)
          else if (code === 's')
            document.execCommand('foreColor', false, this.subQuestionColor)
          document.execCommand('insertText', false, `<${code}>${this.text}</${code}>`)
        } else if (this.text.anchorNode.parentElement === this.$refs.editAreaDiv) {
          if (this.text.anchorNode.data) {
            const div = document.createElement('div')
            const span = document.createElement('span')
            div.appendChild(span)
            if (this.text.anchorNode.childNodes.length > 0)
              span.innerText = this.text.anchorNode.childNodes[0].data
            else span.innerText = this.text.anchorNode.data
            if (code === 'q') {
              span.style.color = this.questionColor
              span.innerText = `<${code}>${span.innerText}</${code}>`
            } else if (code === 'a') {
              span.style.color = this.answerColor
              span.innerText = `<${code}>${span.innerText}</${code}>`
            } else if (code === 's') {
              span.style.color = this.subQuestionColor
              span.innerText = `<${code}>${span.innerText}</${code}>\n`
            }
            this.$refs.editAreaDiv.insertBefore(div, this.text.anchorNode)
            this.$refs.editAreaDiv.removeChild(this.text.anchorNode)
            selRange.setStart(div, 0)
          } else {
            const span = document.createElement('span')
            const text = this.text.anchorNode.innerText
            this.text.anchorNode.innerText = ''
            this.text.anchorNode.appendChild(span)
            span.innerText = text
            if (code === 'q') {
              span.style.color = this.questionColor
              span.innerText = `<${code}>${span.innerText}</${code}>`
            } else if (code === 'a') {
              span.style.color = this.answerColor
              span.innerText = `<${code}>${span.innerText}</${code}>`
            } else if (code === 's') {
              span.style.color = this.subQuestionColor
              span.innerText = `<${code}>${span.innerText}</${code}>\n`
            }
          }
        } else if (this.text.anchorNode.parentElement.nodeName === 'SPAN') {
          if (code === 'q') {
            this.text.anchorNode.parentElement.style.color = this.questionColor
            this.text.anchorNode.parentElement.innerText = `<${code}>${this.text.anchorNode.parentElement.innerText}</${code}>`
          } else if (code === 'a') {
            this.text.anchorNode.parentElement.style.color = this.answerColor
            this.text.anchorNode.parentElement.innerText = `<${code}>${this.text.anchorNode.parentElement.innerText}</${code}>`
          } else if (code === 's') {
            this.text.anchorNode.parentElement.style.color = this.subQuestionColor
            this.text.anchorNode.parentElement.innerText = `<${code}>${this.text.anchorNode.parentElement.innerText}</${code}>`
          }
          const span = this.text.anchorNode.parentElement.cloneNode(true)
          this.$refs.editAreaDiv.insertBefore(span, this.text.anchorNode.parentElement)
          this.$refs.editAreaDiv.removeChild(this.text.anchorNode.parentElement)
          selRange.setStart(span, 0)
        } else if (
          this.text.anchorNode.parentElement.nodeName === 'DIV' &&
          this.text.anchorNode.parentElement !== wrapper
        ) {
          const text = this.text.anchorNode.parentElement.innerText
          if (text !== '\n') {
            this.text.anchorNode.parentElement.innerText = ''
            const div = document.createElement('div')
            const span = document.createElement('span')
            this.$refs.editAreaDiv.insertBefore(div, this.text.anchorNode)
            this.$refs.editAreaDiv.removeChild(this.text.anchorNode)
            div.appendChild(span)
            if (code === 'q') {
              span.style.color = this.questionColor
              span.innerText = `<${code}>${text}</${code}>`
            } else if (code === 'a') {
              span.style.color = this.answerColor
              span.innerText = `<${code}>${text}</${code}>`
            } else if (code === 's') {
              span.style.color = this.subQuestionColor
              span.innerText = `<${code}>${text}</${code}>`
            }
            selRange.setStart(div, 0)
          }
        }
      }
    },
    clearTag() {
      const wrapper = document.querySelector('.text-container')
      if (
        this.text.focusNode &&
        this.$refs.editAreaDiv.contains(this.text.focusNode.parentElement) &&
        this.text.focusNode.parentElement !== this.$refs.editAreaDiv &&
        this.text.focusNode.parentElement !== wrapper
      ) {
        if (this.text.focusNode.parentElement.nodeName !== 'DIV') {
          this.text.focusNode.parentElement.innerHTML = this.text.focusNode.parentElement.innerText.replace(
            /(<\s*[qas][^>]*>)/gi,
            '',
          )
          this.text.focusNode.parentElement.innerHTML = this.text.focusNode.parentElement.innerText.replace(
            /(<\s*\/\s*[qas]>)/gi,
            '',
          )
        }
      } else if (
        this.text.focusNode.parentElement === this.$refs.editAreaDiv &&
        this.text.focusNode.childNodes.length &&
        this.text.focusNode.childNodes[0].nodeName === 'SPAN'
      ) {
        this.text.focusNode.innerHTML = this.text.focusNode.childNodes[0].innerText.replace(
          /(<\s*\/\s*[qas]>)/gi,
          '',
        )
        this.text.focusNode.innerHTML = this.text.focusNode.childNodes[0].innerText.replace(
          /(<\s*\/\s*[qas]>)/gi,
          '',
        )
      }
    },
    async poswind() {
      const updatedSurvey = await this.executeSurveyAPICall({
        method: 'PUT',
        path: 'survey',
        payload: {
          survey_id: this.$store.getters.survey.id_,
          step: 'scheme',
        },
      })
      if (!updatedSurvey) return
      this.surveyRegister(updatedSurvey)
      await this.$router.push('/scheme')
    },
    async saveSurvey() {
      const updatedSurvey = await this.executeSurveyAPICall({
        method: 'PUT',
        path: 'survey',
        payload: {
          survey_id: this.$store.getters.survey.id_,
          text: this.$refs.editAreaDiv.innerText,
        },
      })
      if (!updatedSurvey) return
      this.surveyRegister(updatedSurvey)
      this.sendMessage(this.translations[this.language][this.SURVEY_SAVED])
    },

    async buildSurvey(e) {
      this.loading = true

      const updatedSurvey = await this.executeSurveyAPICall({
        method: 'POST',
        path: 'survey/generate-json',
        payload: {
          text: this.$refs.editAreaDiv.innerText,
          surveyId: this.$store.getters.survey.id_,
        },
      })

      if (!updatedSurvey) return (this.loading = false)

      this.surveyRegister(updatedSurvey)

      window.sessionStorage.setItem('editor', true)

      this.$router.push('/scheme')

      this.loading = false
    },

    bindings(e) {
      if (e.shiftKey & (e.keyCode === keyCodes.numberOne)) {
        // SHIFT + 1
        e.preventDefault()
        this.tag('q')
      } else if (e.shiftKey && e.keyCode === keyCodes.numberTwo) {
        // SHIFT + 2
        e.preventDefault()
        this.tag('a')
      } else if (e.shiftKey && e.keyCode === keyCodes.numberThree) {
        // SHIFT + 3
        e.preventDefault()
        this.tag('s')
      } else if (e.shiftKey && e.keyCode === keyCodes.letterQ) {
        // SHIFT + Q to clear
        e.preventDefault()
        this.clearTag()
      } else if (e.altKey && e.keyCode === keyCodes.letterS) {
        // ALT + S to save
        e.preventDefault()
        this.saveSurvey()
      } else if (e.shiftKey && e.keyCode === keyCodes.fOne) {
        // SHIFT + F1
        e.preventDefault()
        this.group()
      }
    },
    init() {
      this.$el.addEventListener('keydown', this.bindings)
      const editArea = this.$refs.editArea.value
      this.initEditor(editArea)
    },
    hasQuestions() {
      return this.survey.questions_groups.find(group => group.questions.length)
    },
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.$el.removeEventListener('keydown', this.bindings)
  },
}
</script>

<style lang="scss" scoped>
.editor {
  .container {
    padding: 0 10px;
    p {
      @include tipography(14);
      text-transform: capitalize;
      padding: 30px 0 25px;
    }
    h1 {
      @include tipography(26);
      padding: 0 0 20px;
      font-weight: bold;
    }
    h1,
    span {
      color: $white;
    }
    > p {
      color: $gray-6 !important;
    }
  }
  .light & {
    h1,
    span {
      color: $gray-6;
    }
    > p {
      color: $gray;
    }
  }
}

.survey-name {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  padding: 20px 0px;
  border-top: 1px solid $white;

  h2 {
    @include tipography(30);
    text-transform: capitalize;
  }

  .buttons {
    margin-left: 20px;

    button {
      margin-right: 20px;
      padding: 5px 20px;
      background: none;
      border: 2px solid $blue;
      border-radius: 3px;
      cursor: pointer;
      @include tipography(12);
      text-transform: uppercase;
      letter-spacing: 1px;

      &:last-of-type {
        background: $blue;
        margin-right: 0;
      }
    }
  }

  @media (max-width: 985px) {
    flex-direction: column;

    .buttons {
      margin: 20px 0 0;

      button {
        margin-bottom: 15px;

        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }
  }

  a {
    display: flex;
    align-items: center;
    margin-top: 15px;
    @include tipography(14);
    &::before {
      content: '';
      display: block;
      width: 15px;
      height: 15px;
      background: url(../../assets/imgs/back.svg) no-repeat center;
      margin-right: 5px;
    }
  }
  .light & {
    border-top: 1px solid $gray-5;
    h2 {
      color: $main;
    }
    button {
      color: $gray-6;
      &:last-of-type {
        color: $white;
      }
    }
    a {
      color: $gray-9;
      &::before {
        background: url(../../assets/imgs/back_dark.svg) no-repeat center;
      }
    }
  }
}
.editor-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
  padding: 10px;
  background: $gray-8;
  border: 1px solid $gray-2;
  button {
    &:hover {
      color: $main-two;
      transform: scale(1.03);
      box-shadow: 0 0 9px -2px $gray;
    }
    @include tipography(14);
    margin-right: 25px;
    min-width: 100px;
    outline: none;
    border: none;
    padding: 2px 0;
    border-radius: 3px;
    font-weight: bold;
    background: #c992c9;
    border-radius: 30px;
    position: relative;
    cursor: pointer;
    color: #5e1560;
    @include d(s) {
      margin: 5px;
    }
    &#a-tag {
      background: #66a6d3;
      color: #124666;
    }
    &#s-tag {
      background: #d2dd43;
      color: #6b6d14;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
    }
    &#auto-tag {
      background: #e22424;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        border-right: 1px dotted $white;
        display: block;
        height: 30px;
        width: 1px;
        right: -14px;
        @include d(s) {
          display: none;
        }
      }
    }

    &#clear {
      @include flexMiddle;
      background: $transparent;
      min-width: unset;
      position: relative;

      svg {
        width: 25px;
        height: 20px;
      }

      @include d(s) {
        margin-left: 20px;
      }

      &::before {
        content: '';
        position: absolute;
        left: -9px;
        border-left: 1px dotted $white;
        display: block;
        height: 30px;
        width: 1px;
        @include d(s) {
          display: none;
        }
      }

      &:hover {
        transform: scale(1.03);
        box-shadow: none;
      }

      .light & {
        &::before {
          border-color: $gray-5;
        }
      }
    }

    &#foward {
      background: rgba(0, 0, 0, 0);
      border: 2px solid #fff !important;
      color: #fff !important;
      position: relative;
      border-radius: 15px;
      padding: 2px 0;
      &:hover {
        color: gray;
        &::after {
          opacity: 0.5;
        }
      }
    }
    &#save {
      margin-left: auto;
      background: rgba(0, 0, 0, 0);
      border: 2px solid #fff;
      position: relative;
      border-radius: 15px;
      padding: 2px 0;
      color: #fff;
    }
    &#build {
      @include btn-style;
      padding-top: 4px;
      padding-bottom: 4px;
      &:hover {
        color: #fff;
      }
    }

    &.group {
      background: $gray-light-3;
      color: $main-3;

      .light & {
        background: $main-3;
        color: $white;
      }
    }

    &:last-child {
      margin-right: 0;
    }
  }
  .light & {
    background: $white;
    border: none;
    border-bottom: 1px solid $gray-5;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    button {
      &#auto-tag,
      &#s-tag,
      &#clear {
        &::after {
          border-right: 1px dotted $gray-5;
        }
      }
    }
  }
}
.text-container {
  display: flex;
  justify-content: center;
  height: 50vh;
  & > textarea {
    display: none;
  }
  @include d(s) {
    padding: 0 !important;
  }
}
#editor {
  background: $gray-8;
  border: 1px solid $gray-2;
  border-top: none;
  color: white;
  overflow-x: hidden;
  overflow-y: scroll;
  width: 100%;
  padding: 10px;
  font-family: sans-serif;
  font-size: 0.875em;
  line-height: 1.1em;
  letter-spacing: 1px;
  div {
    background: red;
  }
  &:focus {
    outline: none;
  }
  .light & {
    background: $white;
    border: none;
    box-shadow: 0px 10px 25px rgba(176, 181, 199, 0.15);
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    color: $main;
  }
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: #215791;
    border-radius: 10px;
    height: 60px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: $secondary;
  }
}
</style>
